import { useParams } from "react-router-dom";
import { RequireFeature } from "../components/common";
import { FoodDetailPanel } from "../components/food";
import { PageHeader } from "../theme/components";

export function FoodDetailPage() {
  const { refCode = "" } = useParams();
  return (
    <RequireFeature feature="lookup">
      <PageHeader eyebrow="GET /napi/food/search/result/refCode/{refCode}" title="Food details" />
      <FoodDetailPanel refCode={refCode} />
    </RequireFeature>
  );
}
